export const GC_BLANK_DEFAULT = 'GC_BLANK_DEFAULT';
export const BLANK = 'BLANK';
export const referenceDataEndpoint = '/api/v3/reference_data/:refId';